import { AnimBaseProps } from '@/animations/types'
import { DUR, EASE } from '@/animations/vars'
import { contextScrollVars, contextVars } from '@/lib/animations'
import { ScrollTrigger, gsap } from '@gsap'
import { MEDIA } from '@config'

const sectionFadeIn = ({ ...props }: AnimBaseProps) => {
  if (!props.ref.current) return
  // Skip the scroll-triggered fade on mobile: the animation isn't
  // perceptible on small screens, but ScrollTrigger still pays for a
  // scroll listener and recalculations on every section
  if (typeof window !== 'undefined' && !window.matchMedia(MEDIA.sm).matches) {
    return
  }
  gsap.registerPlugin(ScrollTrigger)
  gsap.set(props.ref.current, { autoAlpha: 0, y: '2rem' })
  props.tl = gsap.to(props.ref.current, {
    autoAlpha: 1,
    duration: DUR.default,
    ease: EASE.out,
    clearProps: 'y',
    y: 0,
    ...contextVars(props.ctx, props.animVars),
    scrollTrigger: {
      trigger: props.ref.current,
      start: 'top 80%',
      ...contextScrollVars(props.ctx, props.animScrollVars)
    }
  })
}

export default sectionFadeIn
